export default __webpack_public_path__ + "static/media/mastercard_inverse.0eeb3e42.svg";